__turbopack_context__.v({
  "item": "styles-module__RLapjq__item",
  "text": "styles-module__RLapjq__text",
  "withDivider": "styles-module__RLapjq__withDivider",
});
